import React, { Component } from 'react';
import { openModal, closeModal } from '../../../../common/components/Modal/ModalRedux';
import { bindActionCreators, compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { actions } from '../../redux/brokerActions';
import { Modal, Button, Select } from '../../../../common/components/';

const FORM_NAME = 'primaryContactForm';

class SelectPrimaryContactModal extends Component {
  handleOpen = () => {
    const { dispatch } = this.props;
    dispatch(openModal(FORM_NAME));
  };

  updatePrimaryContact = (application) => {
    const { brokerId, actions, dispatch } = this.props;
    Promise.resolve(actions.setBrokerPrimaryContact(brokerId, application)).then(() => {
      dispatch(closeModal(FORM_NAME));
    });
  };

  render() {
    const { title, handleSubmit, brokerId, isSubmitting } = this.props;
    return (
      <>
        <Button
          bsStyle="primary"
          label={title}
          className="pull-right"
          handleClick={this.handleOpen}
        />
        <Modal
          name={FORM_NAME}
          title={title}
          close
          onHide={this.resetState}
          bsSize="large"
          handleSubmit={handleSubmit(::this.updatePrimaryContact)}
          footer={
            <Button
              type="submit"
              bsStyle="primary"
              loading={isSubmitting}
              label="Set Primary Contact"
            />
          }
        >
          <Field
            name={'data.attributes.broker_primary_contact_id'}
            source={'users'}
            isClearable={true}
            labelPath={'attributes.full_name'}
            optionValuePath={'id'}
            component={Select}
            filter={'?filter[broker]=' + brokerId}
            sourceKey={'userByBroker' + brokerId}
            noCache={true}
          />
        </Modal>
      </>
    );
  }
}

//const form = reduxForm({ form: FORM_NAME })(SelectPrimaryContactModal);
//
export default compose(
  connect(
    (state) => ({
      isSubmitting: state.broker.isSubmitting,
    }),
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
    }),
  ),
  reduxForm({ form: FORM_NAME }),
)(SelectPrimaryContactModal);
